export const getImageBaseUrl = (): string => {
  // Use env value if present
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  console.log("Image Base URL from env:", imageBaseUrl);
  if (imageBaseUrl && imageBaseUrl.trim() !== "") {
    return imageBaseUrl;
  }     

  // some fallback default
  return "https://v3.apis.pococare.com";
};
